import type { SortKey } from "@/utils/movieQuery";

interface SortBarProps {
  sort: SortKey;
  onChange: (sort: SortKey) => void;
  total: number;
  onOpenFilter?: () => void;
  activeFilters?: number;
}

const options: { key: SortKey; label: string }[] = [
  { key: "updated", label: "按更新时间" },
  { key: "hot", label: "按热度" },
  { key: "rating", label: "按评分" },
];

export default function SortBar({ sort, onChange, total, onOpenFilter, activeFilters = 0 }: SortBarProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-background-200/70 bg-background-50 px-4 py-3">
      <p className="text-sm text-foreground-600">
        共找到 <span className="font-bold text-primary-600">{total}</span> 部作品
      </p>

      <div className="flex items-center gap-2">
        {onOpenFilter && (
          <button
            type="button"
            onClick={onOpenFilter}
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/70 bg-background-50 px-3 py-1.5 text-sm font-medium text-foreground-700 lg:hidden"
          >
            <i className="ri-filter-3-line leading-none"></i>
            筛选
            {activeFilters > 0 && (
              <span className="rounded-full bg-accent-500 px-1.5 text-xs font-bold text-primary-950">
                {activeFilters}
              </span>
            )}
          </button>
        )}

        <div className="flex items-center gap-1 rounded-md border border-background-200/70 bg-background-100 p-1">
          {options.map((opt) => (
            <button
              key={opt.key}
              type="button"
              onClick={() => onChange(opt.key)}
              className={`whitespace-nowrap rounded px-3 py-1.5 text-xs font-medium transition-colors ${
                sort === opt.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}